import styled from 'styled-components'

export const LayoutDashboard = styled.div`
  padding: 20px 35px 20px 40px;
`
